export const BASE_URL = 'https://api.platonics.ru/student';

function checkResponse(res) {
    if (res.ok) {
        return res.json();
    }
    return Promise.reject(`${res.status}`);
}

function checkResponseRegister(res) {
    if (res.ok) {
        return res.json();
    }
	if (res.status===400)
		return res.json();
    return Promise.reject(`${res.status}`);
}

export const authorize = (username, password) => {
    return fetch(`${BASE_URL}/login`, {
        method: 'POST',
        // credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
            password: password,
            username: username,
        })
    })
        .then(checkResponse)
};

export const register = (registerData) => {
    return fetch(`${BASE_URL}/register`, {
        method: 'POST',
        // credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(registerData)
    })
        .then(checkResponseRegister)
};

export const logOut = () => {
    return fetch(`${BASE_URL}/logout`, {
        method: 'POST',
        credentials: 'include',
    })
        .then(checkResponse)
}